export const FormBuilderTemplates = {
    builderSidebarFormTemplate(builderEditForm, ctx) {
        let defaultTemplate = builderEditForm(ctx);

        return defaultTemplate
            .replace(/"fa fa-dot-circle-o"/gi, '"fa fa-circle-dot"')
            .replace(/"fa fa-file-pdf"/gi, '"far fa-file-pdf"')
            .replace(/"fa fa-clock-o"/gi, '"far fa-clock"')
            .replace(/"fa fa-html5"/gi, '"fa fa-code"');
    },

    builderComponentFormTemplate(builderComponentForm, ctx) {
        document.querySelector('.details-area').addEventListener('click', evt => {
            if ((evt.target as HTMLElement).parentElement?.classList.contains('component-settings-button-copy')) {
                (evt.target as HTMLElement).parentElement.click();
                ((evt.target as HTMLElement).parentElement.parentElement.querySelector('.component-settings-button-paste') as HTMLElement).click();
            }

            if ((evt.target as HTMLButtonElement).type != 'button') {
                evt.stopPropagation();
                evt.stopImmediatePropagation();
            }
        });

        let defaultTemplate = builderComponentForm(ctx);
        let div = document.createElement('div');
        div.innerHTML = defaultTemplate;

        div.querySelectorAll('.component-settings-button-edit-json').forEach(x => (x as HTMLElement).style.setProperty('display', 'none', 'important'));
        div.querySelectorAll('.component-settings-button-move').forEach(x => x.remove());
        div.querySelectorAll('.component-settings-button-paste').forEach(x => (x as HTMLElement).style.setProperty('display', 'none', 'important'));

        div.querySelectorAll('.builder-component').forEach(x => {
            if (x.querySelector('.formio-component-button') != null) {
                x.querySelectorAll('.component-btn-group .component-settings-button-copy').forEach(y => y.remove());
                x.querySelectorAll('.component-btn-group .component-settings-button-remove').forEach(y => y.remove());
            }
        });

        let finalTemplate = div.innerHTML;

        return finalTemplate
            .replace(/formio-component-datagridCustom/gi, 'formio-component-datagridCustom formio-component-datagrid')
            .replace(/"fa fa-arrows"/gi, '"fa fa-arrows-alt"')
            .replace(/"fa fa-times-circle-o"/gi, '"fa fa-times-circle"')
            .replace(/fa fa-question-sign/gi, 'fas fa-question-circle');
    },

    builderEditFormTemplate(builderEditForm, ctx) {
        let defaultTemplate = builderEditForm(ctx);
        let div = document.createElement('div');
        div.innerHTML = defaultTemplate;

        if (defaultTemplate.includes(' formio-component-inputMask ')) {
            //div.querySelector('.formio-component-inputMask [ref="tooltip"]').attributes['data-tooltip'].value = `
            //    Máscara que será aplicada no campo para garantir que o mesmo tenha um valor predefinido. Use :

            //    - "9", para indicar a entrada de um dígito;
            //    - "a", para indicar o uso de um caracter minúsculo;
            //    - "A", para indicar o uso de um caracter maiúsculo ou minúsculo;
            //    - "*", para indicar o uso de um caracter alfanumérico qualquer.
            //`;
            div.querySelector('.formio-component-inputMask [ref="tooltip"]').attributes['data-tooltip'].value = `
                Máscara que será aplicada no campo para garantir que o mesmo tenha um valor predefinido.
                Use "9" para indicar a entrada de um dígito e "A" para um caracter. Exemplo:
                "(999) AAA-999"
            `;
        }

        let lead = div.querySelector('.row > .col > .lead');
        lead.innerHTML = lead.innerHTML.replaceAll(' Component', '');

        let finalTemplate = div.innerHTML;

        return finalTemplate
            .replace(/"fa fa-times-circle-o"/gi, '"fa fa-times-circle"')
            .replace(/fa fa-question-sign/gi, 'fas fa-question-circle');
    },

    datagridFormTemplate(datagridForm, ctx) {
        let defaultTemplate = datagridForm(ctx);
        let div = document.createElement('div');
        div.innerHTML = defaultTemplate;

        let dada = div.querySelector('.drag-and-drop-alert');
        if (dada != null) {
            let options = ctx.instance.root.components
                .filter(x => !['datagrid', 'components', 'pdfUpload', 'pdfUploadMultiple', 'content', 'button'].includes(x.type))
                .map(x => ({ label: x.component.label, key: x.component.key })).filter(x => x.label != null);

            let htmlContent = '<select class="form-control">';
            for (let x of options) htmlContent += `<option value="${x.key}">${x.label}</option>`;
            htmlContent += '</select>';
            htmlContent += `<button type="button" class="btn btn-outline-success move-component mt-2" data-table-key="${ctx.component.key}">`;
            htmlContent += '<i class="fas fa-reply mr-2"></i><span>Trazer campo</span>';
            htmlContent += '</button>';

            dada.innerHTML = htmlContent;
        }

        let buttons = div.querySelectorAll('.datagrid-table .formio-drag-button');
        buttons.forEach((x: HTMLElement) => x.title = 'Clique e arraste para reordenar');

        let finalTemplate = div.innerHTML;

        return finalTemplate
            .replace(/"fa fa-times-circle-o"/gi, '"fa fa-times-circle"')
            .replace(/fa fa-question-sign/gi, 'fas fa-question-circle')
            .replace(/table-bordered/gi, '')
            .replace(/(button.*btn) btn-secondary (formio-button-remove-row)/gi, '$1 btn-link $2');
    }
}
